/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { XpMultiplier } from './XpMultiplier';
import {
    XpMultiplierFromJSON,
    XpMultiplierFromJSONTyped,
    XpMultiplierToJSON,
    XpMultiplierToJSONTyped,
} from './XpMultiplier';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';
import type { CheatFlagHistoryEntry } from './CheatFlagHistoryEntry';
import {
    CheatFlagHistoryEntryFromJSON,
    CheatFlagHistoryEntryFromJSONTyped,
    CheatFlagHistoryEntryToJSON,
    CheatFlagHistoryEntryToJSONTyped,
} from './CheatFlagHistoryEntry';
import type { DiscordInfo } from './DiscordInfo';
import {
    DiscordInfoFromJSON,
    DiscordInfoFromJSONTyped,
    DiscordInfoToJSON,
    DiscordInfoToJSONTyped,
} from './DiscordInfo';
import type { GamerTag } from './GamerTag';
import {
    GamerTagFromJSON,
    GamerTagFromJSONTyped,
    GamerTagToJSON,
    GamerTagToJSONTyped,
} from './GamerTag';
import type { CookieConsent } from './CookieConsent';
import {
    CookieConsentFromJSON,
    CookieConsentFromJSONTyped,
    CookieConsentToJSON,
    CookieConsentToJSONTyped,
} from './CookieConsent';
import type { DateOfBirthHistoryEntry } from './DateOfBirthHistoryEntry';
import {
    DateOfBirthHistoryEntryFromJSON,
    DateOfBirthHistoryEntryFromJSONTyped,
    DateOfBirthHistoryEntryToJSON,
    DateOfBirthHistoryEntryToJSONTyped,
} from './DateOfBirthHistoryEntry';
import type { AddressBook } from './AddressBook';
import {
    AddressBookFromJSON,
    AddressBookFromJSONTyped,
    AddressBookToJSON,
    AddressBookToJSONTyped,
} from './AddressBook';
import type { UserOrigin } from './UserOrigin';
import {
    UserOriginFromJSON,
    UserOriginFromJSONTyped,
    UserOriginToJSON,
    UserOriginToJSONTyped,
} from './UserOrigin';
import type { SubscriptionTierStatus } from './SubscriptionTierStatus';
import {
    SubscriptionTierStatusFromJSON,
    SubscriptionTierStatusFromJSONTyped,
    SubscriptionTierStatusToJSON,
    SubscriptionTierStatusToJSONTyped,
} from './SubscriptionTierStatus';
import type { AccountStatusHistoryEntry } from './AccountStatusHistoryEntry';
import {
    AccountStatusHistoryEntryFromJSON,
    AccountStatusHistoryEntryFromJSONTyped,
    AccountStatusHistoryEntryToJSON,
    AccountStatusHistoryEntryToJSONTyped,
} from './AccountStatusHistoryEntry';
import type { Asset } from './Asset';
import {
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
    AssetToJSONTyped,
} from './Asset';
import type { PhoneNumber } from './PhoneNumber';
import {
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    PhoneNumberToJSONTyped,
} from './PhoneNumber';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';

/**
 * 
 * @export
 * @interface StandardUser
 */
export interface StandardUser extends User {
    /**
     * 
     * @type {boolean}
     * @memberof StandardUser
     */
    phoneNumberVerified: boolean;
}



/**
 * Check if a given object implements the StandardUser interface.
 */
export function instanceOfStandardUser(value: object): value is StandardUser {
    if (!('phoneNumberVerified' in value) || value['phoneNumberVerified'] === undefined) return false;
    return true;
}

export function StandardUserFromJSON(json: any): StandardUser {
    return StandardUserFromJSONTyped(json, false);
}

export function StandardUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): StandardUser {
    if (json == null) {
        return json;
    }
    return {
        ...UserFromJSONTyped(json, true),
        'phoneNumberVerified': json['phoneNumberVerified'],
    };
}

export function StandardUserToJSON(json: any): StandardUser {
    return StandardUserToJSONTyped(json, false);
}

export function StandardUserToJSONTyped(value?: StandardUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        ...UserToJSONTyped(value, true),
        'phoneNumberVerified': value['phoneNumberVerified'],
    };
}

